/**
 * Returns true for Shopify's synthetic "Title / Default Title" option that
 * appears on products with no real variants. Use this to skip rendering
 * meaningless selectors in the UI.
 */
export function isDefaultSingleVariantOption(opt: {
  name: string;
  value: string;
}) {
  return opt.name === "Title" && opt.value === "Default Title";
}
